import api from '../api';

export const getAppVersionsApi = () => api.get('/AppVersions').then((res) => res.data);
